"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgToken(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 12a5 5 0 015-5 4.996 4.996 0 014.71 3.333h6.123c.11 0 .217.044.295.122l1.25 1.25a.417.417 0 010 .59l-1.25 1.25a.417.417 0 01-.295.122h-1.077l-.711.711a.417.417 0 01-.59 0l-.71-.711h-.49l-.71.711a.417.417 0 01-.59 0l-.71-.711h-.535A4.997 4.997 0 012 12zm5-4.167a4.167 4.167 0 000 8.334 4.165 4.165 0 004.005-3.03.417.417 0 01.4-.304h1.012c.11 0 .216.044.294.122l.539.54.539-.54a.416.416 0 01.294-.122h.834c.11 0 .216.044.294.122l.539.54.539-.54a.416.416 0 01.294-.122h1.078l.833-.833-.833-.833h-6.255a.417.417 0 01-.401-.304A4.164 4.164 0 007 7.833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.333 11.167a.833.833 0 100 1.666.833.833 0 000-1.666zM3.667 12A1.667 1.667 0 117 12a1.667 1.667 0 01-3.333 0zM9 2.455A.46.46 0 019.464 2h12.072a.46.46 0 01.464.455v19.09a.46.46 0 01-.464.455H9.464A.46.46 0 019 21.546v-2.709a.46.46 0 01.464-.454.46.46 0 01.465.454v2.254H21.07V2.909H9.93v2.727a.46.46 0 01-.465.455A.46.46 0 019 5.636V2.455z"
  }));
}

var _default = SvgToken;
exports["default"] = _default;